"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPaginatedResponseOfOrientationSearchResultItemDto = instanceOfPaginatedResponseOfOrientationSearchResultItemDto;
exports.PaginatedResponseOfOrientationSearchResultItemDtoFromJSON = PaginatedResponseOfOrientationSearchResultItemDtoFromJSON;
exports.PaginatedResponseOfOrientationSearchResultItemDtoFromJSONTyped = PaginatedResponseOfOrientationSearchResultItemDtoFromJSONTyped;
exports.PaginatedResponseOfOrientationSearchResultItemDtoToJSON = PaginatedResponseOfOrientationSearchResultItemDtoToJSON;
exports.PaginatedResponseOfOrientationSearchResultItemDtoToJSONTyped = PaginatedResponseOfOrientationSearchResultItemDtoToJSONTyped;
const OrientationSearchResultItemDto_1 = require("./OrientationSearchResultItemDto");
const PaginationMetaDto_1 = require("./PaginationMetaDto");
/**
 * Check if a given object implements the PaginatedResponseOfOrientationSearchResultItemDto interface.
 */
function instanceOfPaginatedResponseOfOrientationSearchResultItemDto(value) {
    if (!('result' in value) || value['result'] === undefined)
        return false;
    if (!('meta' in value) || value['meta'] === undefined)
        return false;
    return true;
}
function PaginatedResponseOfOrientationSearchResultItemDtoFromJSON(json) {
    return PaginatedResponseOfOrientationSearchResultItemDtoFromJSONTyped(json, false);
}
function PaginatedResponseOfOrientationSearchResultItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'result': (json['result'].map(OrientationSearchResultItemDto_1.OrientationSearchResultItemDtoFromJSON)),
        'meta': (0, PaginationMetaDto_1.PaginationMetaDtoFromJSON)(json['meta']),
    };
}
function PaginatedResponseOfOrientationSearchResultItemDtoToJSON(json) {
    return PaginatedResponseOfOrientationSearchResultItemDtoToJSONTyped(json, false);
}
function PaginatedResponseOfOrientationSearchResultItemDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'result': (value['result'].map(OrientationSearchResultItemDto_1.OrientationSearchResultItemDtoToJSON)),
        'meta': (0, PaginationMetaDto_1.PaginationMetaDtoToJSON)(value['meta']),
    };
}
//# sourceMappingURL=PaginatedResponseOfOrientationSearchResultItemDto.js.map